<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <v-data-table
              no-data-text="Нет адресов"
              :headers="headers"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :items="user.addresses"
              :footer-props="footerProps"
              :loading="loading"
              :items-per-page="-1"
              loading-text="Загрузка адресов... Подождите пожалуйста"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click.stop="currentAddress = {}; currentAddress = item">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
    </v-col>
    <address-modal v-model="currentAddress"></address-modal>
  </v-row>
</template>

<script>
    // @ is an alias to /src


    import AddressModal from "../../../components/AddressModal";

    export default {
        name: 'Bonus',
        components: {AddressModal},
        props: {
            value: Object,
            loading: Boolean,
            disabled: Boolean
        },
        data() {
            return {
                currentAddress: {},
                loadingButton: false,
                chargeItem: {
                  description: '',
                  count: 0
                },
                dialog: false,
                user: this.value,
                footerProps: {
                    itemsPerPageText: 'Адресов на страницу',
                    pageText: '',
                    itemsPerPageAllText: 'Все',
                    itemsPerPageOptions: [-1]
                },
                headers: [
                    {
                        text: 'Адрес',
                        value: 'street_obj.name',
                        sortable: false,
                    },
                    {
                        text: 'Номер дома',
                        value: 'home',
                        sortable: false,
                    },
                  {
                    text: 'Название',
                    value: 'name',
                    sortable: false,
                  },
                  {
                    text: 'Парадная',
                    value: 'entrance_number',
                    sortable: false,
                  },
                  {
                    text: 'Код',
                    value: 'code',
                    sortable: false,
                  },
                  {
                    text: 'Этаж',
                    value: 'floor',
                    sortable: false,
                  },
                  {
                    text: 'Квартира',
                    value: 'apartment',
                    sortable: false,
                  },
                  {
                    text: 'Примечание',
                    value: 'comment',
                    sortable: false,
                  },
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        width: '5%'
                    }
                ],
            }
        },
        mounted() {
        },
        watch: {},
        methods: {

        }
    }
</script>

<style lang="scss">
  .category-svg{
    svg{
      width: 37px;
      height: 37px;
      path{
        stroke: #000
      }
    }
  }
  .grouped-row{
    background: #FAFCFF;
  }

</style>

<style lang="scss">
  .grouped-row {
    background: #FAFCFF;
  }

  .table-input {
    .v-input {
      height: 40px;
    }
  }
</style>
<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
